import { render, staticRenderFns } from "./chateau-beaucastel.vue?vue&type=template&id=be36aeca&scoped=true"
import script from "./chateau-beaucastel.vue?vue&type=script&lang=js"
export * from "./chateau-beaucastel.vue?vue&type=script&lang=js"
import style0 from "./chateau-beaucastel.vue?vue&type=style&index=0&id=be36aeca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be36aeca",
  null
  
)

export default component.exports